import { useCallback } from 'react';

import {
  useGetMyMcpAccessQuery,
  useMcpRevokeConnectionMutation,
} from 'gqlhooks';

export const useMyMcpAccess = () => {
  const { data, loading, error, refetch } = useGetMyMcpAccessQuery({
    // Подключения и счётчик вызовов меняются вне этой вкладки (клиент может
    // подключиться в любой момент), поэтому при возврате на страницу
    // перезапрашиваем, а не показываем кэш.
    fetchPolicy: 'cache-and-network',
  });

  return {
    access: data?.myMcpAccess,
    loading,
    error,
    refetch,
  };
};

export const useRevokeMcpConnection = () => {
  const [mutate, { loading }] = useMcpRevokeConnectionMutation();

  const revoke = useCallback(
    async (id: string) => {
      const { data } = await mutate({ variables: { id } });
      const result = data?.revokeMcpConnection;
      const first = result?.customErrors?.[0];
      return {
        success: Boolean(result?.success),
        // Причину называет код (ru/pl фразой в странице); текст бэкенда —
        // только подробностью: он по-русски и в pl-интерфейсе чужой.
        code: first?.code ?? '',
        message: first?.message ?? '',
      };
    },
    [mutate],
  );

  return { revoke, loading };
};
